export enum YesOrNo {
	DEFAULT = '',
	Y = 'YES',
	N = 'NO',
}
